import React from 'react';
import Link from 'next/link';

export default function Footer() {
  const footerLinks = [
    { label: 'About Us', href: '/about' },
    { label: 'Guides', href: '/guides' },
    { label: 'FAQs', href: '/faq' },
    { label: 'Contact Us', href: '/contact' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms and Conditions', href: '/terms' },
    { label: 'Partner with Us', href: '/partner' },
  ];

  return (
    <footer
      style={{
        background: '#ffffff',
        borderTop: '1px solid #e2e8f0',
        padding: '48px 60px 36px',
        textAlign: 'center',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Nav Links */}
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
          {footerLinks?.map((link, i) => (
            <React.Fragment key={link?.label}>
              <Link
                href={link?.href}
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.88rem',
                  color: '#4a5568',
                  textDecoration: 'none',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#00b28a')}
                onMouseLeave={(e) => (e.currentTarget.style.color = '#4a5568')}
              >
                {link?.label}
              </Link>
              {i < footerLinks?.length - 1 && (
                <span style={{ color: '#e2e8f0', fontSize: '0.88rem' }}>·</span>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Copyright */}
        <p
          style={{
            marginTop: '16px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.82rem',
            color: '#8a96a8',
          }}
        >
          © 2026 Lendo LLC. All rights reserved.
        </p>

      </div>
      <style>{`
        @media (max-width: 768px) {
          footer {
            padding: 40px 24px !important;
          }
        }
      `}</style>
    </footer>
  );
}
